export default "__VITE_ASSET__jNJpvIMF__"